import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_URL, getToken } from '../asyncConfig';

export const getAllPaymentMenthods = createAsyncThunk(
  'payments-methods/getAllPaymentMethods', async (_, {rejectWithValue, fulfillWithValue}) => {
    try {
      const {data} = await axios.get(
        `${BASE_URL}/payment_methods`,
        {headers: {Authorization: `Bearer ${getToken()}`}}
      );
      return fulfillWithValue(data.data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
)

export const getMethodFulfilled = (state, action) => {
  console.log('action', action);
  state.status = '';
  state.payment_methods = action.payload;
}

export const addPaymentMethod = createAsyncThunk(
  'payments-methods/add', async (details, {fulfillWithValue, rejectWithValue}) => {
    try {
      const { data } = await axios.post(
        `${BASE_URL}/payment_methods/create`, details,
        {headers: {Authorization: `Bearer ${getToken()}`}}
      );
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
)

export const updatePaymentMethodById = createAsyncThunk(
  'payments-methods/updateById', async ({id, details}, {rejectWithValue, fulfillWithValue}) => {
    try {
      const {data} = await axios.put(
        `${BASE_URL}/payment_methods/update/${id}`, details,
        {headers: {Authorization: `Bearer ${getToken()}`}}
      );
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
)